import { compose } from '@bem-react/core';
import React, { RefObject, memo } from 'react';

import { SimpleCallback } from '../../typings';
import { ImagePopupItem as Item } from '../../typings/images-popup';
import { withOutsideClick } from '../../utils/hocs/withOutsideClick';
import { SCREEN_RESOLUTIONS } from '../image/constants';
import { ImageContextProvider } from '../image/context';
import { withPopupViewRegular } from '../ui/Popup/_view/Popup_view_regular';
import { PopupBase, withTargetAnchor, withZIndex, Direction } from '../ui/Popup/Popup';

import { ImagePopupItem } from './__item/images-popup__item';

import './images-popup.scss';

const Popup = compose(withOutsideClick, withZIndex, withTargetAnchor, withPopupViewRegular)(PopupBase);

interface Props {
    visible: boolean;
    items: Item[];
    scopeRef: RefObject<HTMLElement>;
    anchorRef: RefObject<HTMLElement>;
    offset: number;
    directions: Direction[];
    onClose: SimpleCallback;
}

export const ImagesPopup = memo((props: Props) => {
    const { visible, items, onClose, scopeRef, anchorRef, offset, directions } = props;

    return (
        <ImageContextProvider value={{ resolution: SCREEN_RESOLUTIONS.X1 }}>
            <Popup
                anchor={anchorRef}
                className="images-popup"
                direction={directions}
                ignoreRefs={[anchorRef]}
                mainOffset={offset}
                onClose={onClose}
                scope={scopeRef}
                target="anchor"
                view="regular"
                visible={visible}
            >
                {items.map((item) => (
                    <ImagePopupItem item={item} key={item.url} />
                ))}
            </Popup>
        </ImageContextProvider>
    );
});
